import { DeleteIcon, Edit2Icon, Trash2 } from "lucide-react";
import React, { useState } from "react";

import { sampleUsers, tabs } from "./Data";
import Tabs from "./Tabs";
import UserManagement from "./UserManagement";
import UserResistrations from "./UserResistrations";
import CategoryManagement from "./CategoryManagement";
import CategoryRegistrations from "./CategoryRegistrations";
import ToolManagement from "./ToolManagement";
import ToolRegistration from "./ToolRegistration";
import NotificationManagement from "./NotificationManagement";

export default function Index() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div
      style={{
        borderRadius: 8,
        padding: 32,
        // margin: "84px 40px 100px 40px",
        minHeight: "calc(100vh - 124px)",
        boxSizing: "border-box",
        boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
        display: "block",
      }}
      className="bg-[#bb1ccc]/5"
    >
      <Tabs activeTab={activeTab} setActiveTab={setActiveTab} tabs={tabs} />

      {activeTab === 0 && (
        <>
          <UserManagement sampleUsers={sampleUsers} />
        </>
      )}
      {activeTab === 1 && <UserResistrations />}
      {/* {activeTab === 2 && <NotificationManagement />} */}

    
    </div>
  );
}
